import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "../api/axios";
import CardProductGrid from "../components/CardProductGrid";
import { useTranslation } from "react-i18next";
import { getToken, getUser } from "../auth/auth";

const API_BASE = "https://store.wageh.net/blog"; // ضفنا الرابط عشان مسارات الصور

export default function Home() {
    const { t } = useTranslation();
    const token = getToken(); // <-- ضفنا السطر ده
    const user = getUser();   // <-- وضفنا السطر ده
    const [latestProducts, setLatestProducts] = useState([]);
    const [categories, setCategories] = useState([]); // ستايت جديدة للأقسام
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        // جلب المنتجات
        api.get("/products?limit=4")
            .then((res) => {
                const payload = res.data.data ?? res.data;
                setLatestProducts(payload.data ?? payload);
            })
            .catch((err) => console.log(err));

        // جلب الأقسام
        api.get("/categories")
            .then((res) => {
                const payload = res.data.data ?? res.data;
                setCategories(payload.data ?? payload);
            })
            .catch((err) => console.log(err))
            .finally(() => setLoading(false));
    }, []);

    const addToCart = (id) => {
        console.log("Add to cart:", id);
    };

    return (
        <React.Fragment>
            {/* 1. Banner Section */}
            <div className="container-fluid mb-3 mt-3">
                <div className="bg-primary text-white rounded p-5 text-center shadow-sm" style={{ background: "linear-gradient(90deg, #0d6efd, #0dcaf0)" }}>
                    <h1 className="display-4 fw-bold mb-3">{t("welcome_title")}</h1>
                    <p className="lead mb-4">{t("welcome_desc")}</p>
                    <Link to="/products" className="btn btn-light btn-lg fw-bold text-primary px-5 rounded-pill">
                        {t("shop_now")}
                    </Link>
                </div>
            </div>

            {/* 2. Main Content Layout (9 Cols / 3 Cols) */}
            <div className="container-fluid bg-light mb-4 py-4">
                <div className="row g-4 px-2">
                    {/* الجانب الأيسر - 9 أعمدة */}
                    <div className="col-md-9">
                        <div className="row g-3 mb-4 text-center">
                            {categories.length > 0 ? (
                                categories.map((cat, idx) => {
                                    // مصفوفة أيقونات مميزة عشان تتوزع على الأقسام أوتوماتيك
                                    const iconsList = [
                                        "bi-laptop", "bi-headphones", "bi-phone", "bi-tv",
                                        "bi-smartwatch", "bi-speaker", "bi-camera", "bi-controller",
                                        "bi-pc-display", "bi-mouse"
                                    ];
                                    // اختيار الأيقونة بناءً على الترتيب (عشان لو الأقسام زادت ترجع تعيد من الأول)
                                    const iconClass = iconsList[idx % iconsList.length];

                                    return (
                                        <div key={cat.id} className="col-6 col-md-4 col-lg-3">
                                            <Link
                                                to={`/products?category=${cat.id}`}
                                                className="card border-0 shadow-sm text-decoration-none py-4 hover-up h-100 d-flex flex-column justify-content-center align-items-center"
                                            >
                                                <i className={`bi ${iconClass} display-4 text-primary mb-3`}></i>
                                                <h6 className="text-dark fw-bold m-0">{cat.name}</h6>
                                            </Link>
                                        </div>
                                    );
                                })
                            ) : (
                                <div className="col-12 text-center py-5 text-muted">
                                    <div className="spinner-border text-primary mb-2" role="status"></div>
                                    <p>{t("loading_cats") || "جاري تحميل الأقسام..."}</p>
                                </div>
                            )}
                        </div>
                        {/* تم إزالة بانر الدعم الفني ونقله للفوتر كما طلبت */}
                    </div>

                    {/* الجانب الأيمن - 3 أعمدة */}
                    <div className="col-md-3">
                        {!token ? (
                            // 1. لو زائر (مش مسجل دخول): اعرض كارت الدخول
                            <div className="card border-0 shadow-sm mb-3 bg-white text-center p-4">
                                <h5 className="fw-bold">{t("welcome_user") || "مرحباً بك"}</h5>
                                <p className="text-muted small">{t("login_desc") || "سجل الدخول لمتابعة طلباتك"}</p>
                                <Link to="/login" className="btn btn-primary w-100 mb-2">{t("login_btn") || "تسجيل الدخول"}</Link>
                                <Link to="/register" className="btn btn-outline-secondary w-100">{t("register_btn") || "إنشاء حساب"}</Link>
                            </div>
                        ) : (
                            // 2. لو مسجل دخول (عميل أو آدمن): اعرض كارت ترحيب باسمه
                            <div className="card border-0 shadow-sm mb-3 bg-white text-center p-4">
                                <div className="bg-light rounded-circle mx-auto d-flex align-items-center justify-content-center mb-3" style={{ width: "60px", height: "60px" }}>
                                    <i className="bi bi-person-check fs-1 text-primary"></i>
                                </div>
                                <h5 className="fw-bold m-0 mb-2">مرحباً، {user?.name?.split(' ')[0]}</h5>
                                <p className="text-muted small mb-3">سعداء بعودتك للمتجر!</p>

                                {/* لو آدمن وديه للوحة التحكم، لو عميل وديه لطلباته */}
                                {user?.role === "admin" ? (
                                    <Link to="/admin/dashboard" className="btn btn-warning w-100 fw-bold shadow-sm">
                                        <i className="bi bi-speedometer2 me-2"></i> لوحة الإدارة
                                    </Link>
                                ) : (
                                    <Link to="/orders" className="btn btn-primary w-100 fw-bold shadow-sm">
                                        <i className="bi bi-box-seam me-2"></i> طلباتي
                                    </Link>
                                )}
                            </div>
                        )}
                    </div>
                </div>
            </div>

            {/* 3. Deals of the Day */}
            <div className="container-fluid mb-5">
                <div className="card border-0 shadow-sm">
                    <div className="card-header bg-white border-bottom-0 pt-4 pb-0 d-flex justify-content-between align-items-center">
                        <h4 className="fw-bold m-0 border-start border-primary border-4 ps-2 pe-2">{t("deals_today")}</h4>
                        <Link to="/products" className="btn btn-sm btn-outline-primary">{t("view_all")}</Link>
                    </div>
                    <div className="card-body">
                        {loading ? (
                            <div className="text-center py-5">
                                <div className="spinner-border text-primary" role="status"></div>
                            </div>
                        ) : (
                            <div className="row g-4">
                                {latestProducts.length > 0 ? (
                                    latestProducts.slice(0, 4).map((product, idx) => (
                                        <div key={idx} className="col-12 col-sm-6 col-md-4 col-lg-3">
                                            <CardProductGrid product={product} onAddToCart={addToCart} />
                                        </div>
                                    ))
                                ) : (
                                    <div className="text-center py-4 text-muted">{t("no_deals")}</div>
                                )}
                            </div>
                        )}
                    </div>
                </div>
            </div>

            {/* 4. Explore Collection (Dynamic Categories) */}
            <div className="bg-info bg-gradient p-3 text-center mb-4 shadow-sm text-white">
                <h4 className="m-0 fw-bold">{t("explore_collection")}</h4>
            </div>

            <div className="container mb-5">
                <div className="row g-4 justify-content-center">
                    {categories.length > 0 ? (
                        categories.slice(0, 4).map((category) => {
                            // تظبيط مسار الصورة زي ما عملنا في المنتجات
                            const cleanPath = category.image ? category.image.replace(/^\/+/, '').replace(/^storage\//, '').replace(/^uploads\//, '') : "";
                            const imgSrc = category.image
                                ? (category.image.startsWith("http") ? category.image : `${API_BASE}/uploads/${cleanPath}`)
                                : null;

                            return (
                                <div className="col-6 col-md-3 text-center" key={category.id}>
                                    <Link to={`/products?category=${category.id}`} className="text-decoration-none fashion-link">
                                        <div className="rounded-circle overflow-hidden shadow-sm mx-auto mb-3 bg-white d-flex align-items-center justify-content-center" style={{ width: "150px", height: "150px", border: "3px solid #f8f9fa" }}>
                                            {imgSrc ? (
                                                <img
                                                    src={imgSrc}
                                                    className="img-fluid w-100 h-100"
                                                    style={{ objectFit: "cover" }}
                                                    alt={category.name}
                                                    onError={(e) => {
                                                        e.target.style.display = 'none'; // لو الصورة فيها مشكلة هنخفيها
                                                    }}
                                                />
                                            ) : (
                                                // لو القسم مفيهوش صورة، هنعرض أيقونة بديلة شيك
                                                <i className="bi bi-tags display-4 text-muted opacity-50"></i>
                                            )}
                                        </div>
                                        <h6 className="text-dark fw-bold">{category.name}</h6>
                                    </Link>
                                </div>
                            );
                        })
                    ) : (
                        <div className="text-center text-muted w-100">جاري تحميل الأقسام...</div>
                    )}
                </div>
            </div>

            <style>{`
                .hover-up { transition: transform 0.3s ease; }
                .hover-up:hover { transform: translateY(-5px); }
                .fashion-link:hover h6 { color: #0d6efd !important; }
                .fashion-link img { transition: transform 0.3s ease; }
                .fashion-link:hover img { transform: scale(1.1); }
            `}</style>
        </React.Fragment>
    );
}